"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _serializr = require("serializr");
var _lodash = require("lodash");
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _api = _interopRequireDefault(require("./api"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_LIMIT = 20;
var RootStore = (_class = /*#__PURE__*/function () {
  function RootStore() {
    (0, _classCallCheck2["default"])(this, RootStore);
    (0, _initializerDefineProperty2["default"])(this, "indexData", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "showData", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "metaData", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "page", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "filters", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "sort", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "filterInitialized", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "limit", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "requestCounter", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "initialRequestReceived", _descriptor0, this);
    (0, _initializerDefineProperty2["default"])(this, "showLoadingIcon", _descriptor1, this);
    (0, _initializerDefineProperty2["default"])(this, "indexDataFullyLoaded", _descriptor10, this);
    (0, _initializerDefineProperty2["default"])(this, "errors", _descriptor11, this);
    (0, _initializerDefineProperty2["default"])(this, "formFields", _descriptor12, this);
    (0, _initializerDefineProperty2["default"])(this, "requiredFields", _descriptor13, this);
    (0, _initializerDefineProperty2["default"])(this, "pristineFormCache", _descriptor14, this);
    (0, _initializerDefineProperty2["default"])(this, "formCache", _descriptor15, this);
    (0, _initializerDefineProperty2["default"])(this, "queryStrings", _descriptor16, this);
    (0, _initializerDefineProperty2["default"])(this, "ids", _descriptor17, this);
  }
  return (0, _createClass2["default"])(RootStore, [{
    key: "hasShowData",
    get: function get() {
      return (0, _utils.isPresent)(this.showData);
    }
  }, {
    key: "hasIndexData",
    get: function get() {
      return (0, _utils.isPresent)(this.indexData);
    }
  }, {
    key: "hasOutstandingRequests",
    get: function get() {
      return this.requestCounter > 0;
    }
  }, {
    key: "pagesCount",
    get: function get() {
      return Math.ceil((this.totalCount || 0) / this.limit);
    }
  }, {
    key: "totalCount",
    get: function get() {
      return this.metaData && this.metaData.totalCount;
    }

    // FILTERING
  }, {
    key: "setSort",
    value: function setSort(column) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.sort = column;
      if (params.refresh) {
        this.reloadIndexFiltered({
          ids: params.ids
        });
      }
    }
  }, {
    key: "setQueryStrings",
    value: function setQueryStrings(queryStrings) {
      this.queryStrings = queryStrings;
    }
  }, {
    key: "incrementPage",
    value: function incrementPage(increment, params) {
      this.page = parseInt(this.page, 10) + increment;
      this.reloadIndexFiltered(params);
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      this.page = page;
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      this.filters = {};
    }
  }, {
    key: "hasFilterValue",
    value: function hasFilterValue(key) {
      return (0, _lodash.keys)(this.filters).includes(key);
    }
  }, {
    key: "setLimit",
    value: function setLimit(limit) {
      this.limit = limit;
    }
  }, {
    key: "setFilters",
    value: function setFilters(filters) {
      this.filters = filters;
    }
  }, {
    key: "setFilter",
    value: function setFilter(key, value) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (value === null || value === 'null') {
        return;
      }
      if ((0, _utils.isPresent)(value) && value.constructor.name === 'ObservableArray') {
        value = (0, _mobx.toJS)(value);
      }
      if ((0, _lodash.isArray)(value) && (0, _lodash.isEmpty)(value)) {
        value = '';
      }
      if (params.skipSave) {
        this.clearFilter();
      }
      this.filters[key] = value;
      if (this.filterNamespace && !params.skipSave && !params.skipCookie) {
        var stringifiedValue = (0, _lodash.isArray)(value) ? "[".concat(value.join('||'), "]") : value;
        (0, _utils.setCookieValue)("".concat(this.filterNamespace, "_").concat(key), stringifiedValue);
      }
      if (params.refresh) {
        this.setPage(1);
        this.reloadIndexFiltered({
          ids: params.ids
        });
      }
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      delete this.filters[key];
      if (params.persistRemoval) {
        (0, _utils.setCookieValue)("".concat(this.filterNamespace, "_").concat(key), 'null');
      } else {
        (0, _utils.removeCookie)("".concat(this.filterNamespace, "_").concat(key));
      }
      if (params.refresh) {
        this.setPage(1);
        this.reloadIndexFiltered({
          ids: params.ids
        });
      }
    }
  }, {
    key: "initializeFilters",
    value: function initializeFilters(defaultFilters, filters, defaultSort, namespace, queryStrings, limit, ids) {
      var _this = this;
      this.clearFilter();
      this.filterNamespace = namespace;
      if (defaultFilters) {
        (0, _lodash.each)((0, _lodash.keys)(defaultFilters), function (key) {
          _this.setFilter(key, defaultFilters[key]);
        });
      }
      (0, _lodash.each)(filters, function (filter) {
        _this.setFilter(filter.name, _this.getInitialFilterValue(filter));
      });
      this.limit = limit;
      this.sort = defaultSort;
      this.queryStrings = queryStrings || {};
      this.reloadIndexFiltered({
        ids: ids
      });
      this.filterInitialized = true;
    }
  }, {
    key: "getInitialFilterValue",
    value: function getInitialFilterValue(filter) {
      var value = (0, _utils.getCookieValue)("".concat(this.filterNamespace, "_").concat(filter.name));
      if (value && value[0] === '[') {
        value = value.substring(1, value.length - 1);
        return value.split('||');
      }
      if (value !== null && value !== 'undefined' && value !== undefined) {
        return value;
      }
      return filter["default"];
    }
  }, {
    key: "getFilterValue",
    value: function getFilterValue(key) {
      return (0, _utils.isPresent)(this.filters[key]) && this.filters[key] !== 'undefined' ? this.filters[key] : '';
    }
  }, {
    key: "sortIsAscending",
    value: function sortIsAscending() {
      if ((0, _utils.isBlank)(this.sort)) {
        return null;
      }
      return this.sort[0] !== '-';
    }
  }, {
    key: "sortColumn",
    value: function sortColumn() {
      if (!(0, _utils.isBlank)(this.sort) && this.sort[0] === '-') {
        return this.sort.substring(1, this.sort.length);
      }
      return this.sort;
    }

    // SETTER
  }, {
    key: "set",
    value: function set(field, value) {
      this[field] = value;
    }
  }, {
    key: "incrementMetaData",
    value: function incrementMetaData(field, increment) {
      if ((0, _utils.isBlank)(this.metaData)) {
        return;
      }
      this.metaData[field] = this.metaData[field] + increment;
    }

    // INDEX
  }, {
    key: "getIndex",
    value: function getIndex(params, cb) {
      var _this2 = this;
      if (this.indexDataFullyLoaded) {
        return;
      }
      this.ids = params ? params.ids : null;
      if (params && params.filters) {
        (0, _lodash.each)((0, _lodash.keys)(params.filters), function (filterKey) {
          if (params.filters[filterKey] !== null && params.filters[filterKey] !== null) {
            _this2.setFilter(filterKey, params.filters[filterKey]);
          }
        });
      }
      if (params && params.limit && params.limit !== DEFAULT_LIMIT) {
        this.limit = params.limit;
      }
      if (params && params.sort) {
        this.sort = params.sort;
      }
      var queryStrings = params && params.queryStrings ? params.queryStrings : null;
      var apiParams = {
        ids: this.ids,
        queryStrings: queryStrings
      };
      if (params !== null && params !== void 0 && params.failureCallback) {
        apiParams.failureCallback = params.failureCallback;
      }
      if (params !== null && params !== void 0 && params.onRequestError) {
        apiParams.onRequestError = params.onRequestError;
      }
      if (params !== null && params !== void 0 && params.timeout) {
        apiParams.timeout = params.timeout;
      }
      return this.api(apiParams, (0, _lodash.isFunction)(cb) ? cb : this.afterGetIndex, 'GET', 'index', params && params.filters || this.limit !== DEFAULT_LIMIT || !(0, _utils.isBlank)(this.sort));
    }
  }, {
    key: "getIndexPromise",
    value: function getIndexPromise(params) {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.getIndex(params, function (resp) {
          _this3.afterGetIndex(resp);
          resolve(resp);
        });
      });
    }
  }, {
    key: "getIndexFiltered",
    value: function getIndexFiltered() {
      this.api({}, this.afterGetIndex, 'GET', 'index', true);
    }
  }, {
    key: "setIndexData",
    value: function setIndexData(indexData, params) {
      var _this4 = this;
      this.metaData = indexData.meta;
      var data = indexData.meta ? indexData.data : indexData;
      if ((0, _utils.isPresent)(data) && (0, _lodash.isArray)(data)) {
        var newIndexData = data.map(function (obj) {
          if (_this4.config.model && _this4.config.deserialize) {
            return (0, _serializr.deserialize)(_this4.config.model, obj);
          }
          if (_this4.config.model) {
            return new _this4.config.model(obj);
          }
          return obj;
        });
        if ((0, _utils.isPresent)(params) && params.addToIndexData) {
          this.indexData = [].concat((0, _toConsumableArray2["default"])(this.indexData), (0, _toConsumableArray2["default"])(newIndexData));
        } else {
          this.indexData = newIndexData;
        }
      } else if ((0, _utils.isBlank)(data) && (0, _lodash.isArray)(data)) {
        if (params !== null && params !== void 0 && params.addToIndexData) {
          this.indexDataFullyLoaded = true;
        } else {
          this.indexData = [];
        }
      }
    }
  }, {
    key: "afterGetIndex",
    value: function afterGetIndex(resp) {
      this.setIndexData(resp);
    }
  }, {
    key: "reloadIndex",
    value: function reloadIndex(callback) {
      var cb = (0, _lodash.isFunction)(callback) ? callback : this.afterGetIndex;
      this.api({}, cb, 'GET', 'index');
    }
  }, {
    key: "reloadIndexFiltered",
    value: function reloadIndexFiltered(params) {
      this.ids = params && params.ids ? params.ids : null;
      var cb = params && (0, _lodash.isFunction)(params.callback) ? params.callback : this.afterGetIndex;
      return this.api({
        ids: this.ids,
        queryStrings: params && params.queryStrings
      }, cb, 'GET', 'index', true);
    }
  }, {
    key: "clearIndexData",
    value: function clearIndexData() {
      this.metaData = null;
      this.page = 1;
      this.initialRequestReceived = false;
      this.indexDataFullyLoaded = false;
      this.queryStrings = {};
      this.indexData = [];
    }
  }, {
    key: "resetIndexDataArray",
    value: function resetIndexDataArray() {
      this.indexData = [];
    }
  }, {
    key: "pluckIndex",
    value: function pluckIndex(column) {
      return this.indexData.map(function (item) {
        return item[column];
      });
    }

    // ERRORS
  }, {
    key: "getError",
    value: function getError(fieldName) {
      return this.errors[fieldName];
    }

    // SHOW
  }, {
    key: "getShow",
    value: function getShow(params, callback) {
      var _this5 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.params = params;
      this.ids = (0, _utils.isPresent)(params) ? params.ids : {};
      this.queryStrings = params && params.queryStrings ? params.queryStrings : null;
      var apiParams = {
        ids: this.ids,
        queryStrings: this.queryStrings
      };
      if (options.failureCallback) {
        apiParams.failureCallback = options.failureCallback;
      }
      if (options.onRequestError) {
        apiParams.onRequestError = options.onRequestError;
      }
      if (options.timeout) {
        apiParams.timeout = options.timeout;
      }
      return this.api(apiParams, function (resp) {
        (callback || _this5.afterGetShow.bind(_this5))(resp);
        if (options.successCallback) {
          options.successCallback(resp);
        }
      }, 'GET', 'show');
    }
  }, {
    key: "getShowPromise",
    value: function getShowPromise() {
      var _this6 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (successCallback, failureCallback) {
        _this6.getShow(params, null, {
          successCallback: successCallback,
          failureCallback: failureCallback
        });
      });
    }
  }, {
    key: "setShowData",
    value: function setShowData(obj) {
      if ((0, _lodash.isEmpty)(obj)) {
        this.showData = {};
      } else if (this.config && this.config.deserialize) {
        this.showData = (0, _serializr.deserialize)(this.config.model, obj);
      } else if (this.config && this.config.model) {
        this.showData = new this.config.model(obj);
      } else {
        this.showData = obj;
      }
    }
  }, {
    key: "reloadShow",
    value: function reloadShow(callback) {
      this.api({
        ids: this.ids,
        queryStrings: this.queryStrings
      }, (0, _lodash.isFunction)(callback) ? callback : this.afterGetShow, 'GET', 'show');
    }
  }, {
    key: "clearShowData",
    value: function clearShowData() {
      this.initialRequestReceived = false;
      this.showData = {};
    }
  }, {
    key: "afterGetShow",
    value: function afterGetShow(resp) {
      this.setShowData(resp);
    }
  }, {
    key: "showDataField",
    value: function showDataField(field) {
      return (0, _lodash.get)(this.showData, field);
    }

    // CREATE
  }, {
    key: "create",
    value: function create(params, callback) {
      if (this.beforeCreate) {
        this.beforeCreate();
      }
      var cb = (0, _lodash.isFunction)(callback) ? callback : this.afterCreate;
      this.api(params, cb, 'POST', 'create');
    }
  }, {
    key: "multipartCreate",
    value: function multipartCreate(params, callback) {
      var cb = (0, _lodash.isFunction)(callback) ? callback : this.afterCreate;
      this.api(params, cb, 'MULTIPART_POST', 'create');
    }
  }, {
    key: "afterCreate",
    value: function afterCreate() {
      this.getIndex();
    }

    // UPDATE
  }, {
    key: "update",
    value: function update(params, callback) {
      if (this.showData && this.showData.updatedAt) {
        this.showData.updatedAt = new Date().toString();
      }
      this.setQueryStrings(params.queryStrings);
      var cb = (0, _lodash.isFunction)(callback) ? callback : this.afterUpdate;
      this.api(params, cb, 'PUT', 'update');
    }
  }, {
    key: "afterUpdate",
    value: function afterUpdate() {
      if (this.config.GET && this.config.GET.show) {
        this.reloadShow();
      }
    }
  }, {
    key: "updatePromise",
    value: function updatePromise(params) {
      var _this7 = this;
      return new Promise(function (successCallback, failureCallback) {
        return _this7.update(_objectSpread(_objectSpread({}, params), {}, {
          failureCallback: failureCallback
        }), successCallback);
      });
    }
  }, {
    key: "createPromise",
    value: function createPromise(params) {
      var _this8 = this;
      return new Promise(function (successCallback, failureCallback) {
        return _this8.create(_objectSpread(_objectSpread({}, params), {}, {
          failureCallback: failureCallback
        }), successCallback);
      });
    }
  }, {
    key: "destroyPromise",
    value: function destroyPromise(params) {
      var _this9 = this;
      return new Promise(function (successCallback, failureCallback) {
        return _this9.destroy(_objectSpread(_objectSpread({}, params), {}, {
          failureCallback: failureCallback
        }), successCallback);
      });
    }

    // DESTROY
  }, {
    key: "destroy",
    value: function destroy(params, callback) {
      var cb = (0, _lodash.isFunction)(callback) ? callback : this.afterDestroy;
      this.setQueryStrings(params.queryStrings);
      this.api(params, cb, 'DELETE', 'destroy');
    }
  }, {
    key: "afterDestroy",
    value: function afterDestroy() {
      this.reloadIndexFiltered({});
    }

    // FORM
  }, {
    key: "serializedFormCache",
    get: function get() {
      return (0, _lodash.pick)((0, _mobx.toJS)(this.formCache), (0, _mobx.toJS)(this.formFields));
    }
  }, {
    key: "initializeForm",
    value: function initializeForm() {
      this.formCache = (0, _serializr.deserialize)(this.config.model, {});
      this.pristineFormCache = (0, _serializr.deserialize)(this.config.model, {});
      this.formFields = [];
      this.requiredFields = [];
    }
  }, {
    key: "setFormCacheValue",
    value: function setFormCacheValue(field, value) {
      this.formCache[field] = value;
    }
  }, {
    key: "initializeFormCacheValue",
    value: function initializeFormCacheValue(field, value) {
      this.formCache[field] = value;
      this.pristineFormCache[field] = value;
    }
  }, {
    key: "dirtyForm",
    get: function get() {
      return !(0, _fastDeepEqual["default"])((0, _mobx.toJS)(this.formCache), (0, _mobx.toJS)(this.pristineFormCache));
    }
  }, {
    key: "resetPristine",
    value: function resetPristine() {
      this.pristineFormCache = (0, _lodash.clone)((0, _mobx.toJS)(this.formCache));
    }
  }, {
    key: "resetFormCache",
    value: function resetFormCache() {
      this.formCache = (0, _lodash.clone)((0, _mobx.toJS)(this.pristineFormCache));
    }
  }, {
    key: "registerFormField",
    value: function registerFormField(name, required) {
      if (!this.formFields.includes(name)) {
        this.formFields.push(name);
        if (required) {
          this.requiredFields.push(name);
        }
      }
    }

    // AJAX
  }, {
    key: "afterRequestRecieved",
    value: function afterRequestRecieved() {
      this.requestCounter -= 1;
      this.initialRequestReceived = true;
      this.showLoadingIcon = false;
    }
  }, {
    key: "getUrl",
    value: function getUrl(params, routeVerb, routeAction) {
      var urlParams = params.ids;
      var url = new _models.UrlBuilder(this.config).buildFromUrls(routeVerb, routeAction, urlParams);
      if (routeAction.toLowerCase().includes('index')) {
        url = this.wrapQueryString(url);
        return url;
      }
    }
  }, {
    key: "api",
    value: function api(params, callback, routeVerb, routeAction) {
      this.requestCounter += 1;
      this.showLoadingIcon = true;
      var urlParams = params.ids;
      var url = new _models.UrlBuilder(this.config).buildFromUrls(routeVerb, routeAction, urlParams);
      if (url) {
        if (routeAction === 'index') {
          url = this.wrapQueryString(url);
        }
        return _api["default"].ajax({
          method: routeVerb,
          url: url,
          queryStrings: params.queryStrings || this.queryStrings,
          data: {
            data: params.data
          },
          successCallback: (0, _lodash.isFunction)(callback) ? callback.bind(this) : function () {},
          failureCallback: params.failureCallback || this.onFailure,
          onRequestError: params.onRequestError,
          afterRequestRecieved: this.afterRequestRecieved.bind(this),
          ids: params.ids,
          timeout: params.timeout
        });
      } else {
        var _this$config$model;
        console.error("SEEDLANG ERROR: No listing was found for ".concat(routeVerb, "/").concat(routeAction, " in store ").concat((_this$config$model = this.config.model) === null || _this$config$model === void 0 ? void 0 : _this$config$model.name, "."));
        return null;
      }
    }
  }, {
    key: "apiPromise",
    value: function apiPromise(params, routeVerb, routeAction) {
      var _this0 = this;
      return new Promise(function (resolve, reject) {
        var successCallback = resolve;
        var failureCallback = reject;
        var onRequestError = reject;
        _this0.api(_objectSpread(_objectSpread({}, params), {}, {
          failureCallback: failureCallback,
          onRequestError: onRequestError
        }), successCallback, routeVerb, routeAction);
      });
    }
  }, {
    key: "appendObjectToUrl",
    value: function appendObjectToUrl(url, obj) {
      var queryString = Object.keys(obj).filter(function (key) {
        return obj[key] !== '' && obj[key] !== null || key.match('joins');
      }).flatMap(function (key) {
        var value = obj[key];
        if ((0, _lodash.isArray)(value)) {
          return ["".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value.map(function (item) {
            return String(item);
          }).join(',')))];
        }
        return ["".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)))];
      }).join('&');
      return url.match(/\?/) || url.match('%3F') ? "".concat(url, "&").concat(queryString) : "".concat(url, "?").concat(queryString);
    }
  }, {
    key: "wrapQueryString",
    value: function wrapQueryString(url) {
      var obj = {};
      if (!(0, _utils.isBlank)(this.sort)) {
        obj.sort = this.sort;
      }
      if (!(0, _utils.isBlank)(this.filters)) {
        var mappedFilters = (0, _mobx.toJS)(this.filters);
        mappedFilters = (0, _lodash.mapValues)(mappedFilters, function (v) {
          return v === undefined || v === 'undefined' ? '' : v;
        });
        mappedFilters = (0, _lodash.mapKeys)(mappedFilters, function (v, k) {
          return "filters[".concat(k, "]");
        });
        obj = (0, _lodash.merge)(obj, mappedFilters);
      }
      if (!(0, _utils.isBlank)(this.limit)) {
        obj.limit = this.limit;
      }
      if (!(0, _utils.isBlank)(this.page)) {
        obj.page = this.page;
      }
      if ((0, _lodash.isEmpty)(obj)) {
        return url;
      }
      var updatedUrl = this.appendObjectToUrl(url, obj);
      return updatedUrl;
    }
  }, {
    key: "onFailure",
    value: function onFailure() {}
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "indexData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "metaData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "page", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "filters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "sort", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "filterInitialized", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "limit", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return DEFAULT_LIMIT;
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "requestCounter", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor0 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initialRequestReceived", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor1 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showLoadingIcon", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "indexDataFullyLoaded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "errors", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "formFields", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "requiredFields", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pristineFormCache", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "formCache", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "queryStrings", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "ids", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasShowData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasShowData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasIndexData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasIndexData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasOutstandingRequests", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOutstandingRequests"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pagesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pagesCount"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "totalCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalCount"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setSort", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSort"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setQueryStrings", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setQueryStrings"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "incrementPage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementPage"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setPage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPage"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "clearFilter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilter"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFilterValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "hasFilterValue"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setLimit", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setLimit"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setFilters", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFilters"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setFilter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFilter"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "removeFilter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeFilter"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initializeFilters", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFilters"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getInitialFilterValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getInitialFilterValue"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getFilterValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getFilterValue"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "sortIsAscending", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "sortIsAscending"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "sortColumn", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "sortColumn"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "set", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "serializedFormCache", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "serializedFormCache"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initializeForm", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeForm"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setFormCacheValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFormCacheValue"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initializeFormCacheValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFormCacheValue"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "dirtyForm", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "dirtyForm"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetPristine", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetPristine"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetFormCache", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetFormCache"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "registerFormField", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "registerFormField"), _class.prototype), _class);
var _default = exports["default"] = RootStore;